import React, { useState, useEffect } from 'react';
import { Download } from 'lucide-react';

export default function BottoneInstallaApp({ variante = "navbar" }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIos, setIsIos] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [mostraGuidaIos, setMostraGuidaIos] = useState(false);

  useEffect(() => {
    // Verifica se è già installata in standalone
    const giaInstallata = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (giaInstallata) {
      setIsStandalone(true);
      return;
    }

    // Rileva iOS Safari
    const ua = window.navigator.userAgent.toLowerCase();
    const eIos = /iphone|ipad|ipod/.test(ua);
    setIsIos(eIos);

    // Cattura evento Chrome/Android
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  useEffect(() => {
    const onInstalled = () => setIsStandalone(true);
    window.addEventListener('appinstalled', onInstalled);
    return () => window.removeEventListener('appinstalled', onInstalled);
  }, []);

  if (isStandalone) return null; // Non mostrare se già aperta come app

  const handleInstalla = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null);
      }
    } else if (isIos) {
      setMostraGuidaIos(true);
    } else {
      // Fallback per browser desktop
      alert("Per installare l'app, clicca sull'icona con lo schermo o il '+' nella barra degli indirizzi del tuo browser.");
    }
  };

  return (
    <>
      <button
        onClick={handleInstalla}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all shadow-sm ${
          variante === "navbar"
            ? "bg-[#162D4A] hover:bg-[#0F1F33] text-white border border-[#D4AF37]/40"
            : "bg-[#FDFBF7] hover:bg-white text-[#162D4A] border border-[#CBD5E1]"
        }`}
        title="Installa 6amico sul tuo dispositivo"
      >
        <Download size={14} aria-hidden />
        <span>Installa App</span>
      </button>

      {/* Modal istruzioni per iPhone / iPad */}
      {mostraGuidaIos && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-[#FDFBF7] border border-[#D4AF37]/50 rounded-2xl p-6 max-w-sm w-full shadow-2xl text-[#0F172A]">
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-bold text-base text-[#162D4A]">Installa 6amico su iPhone</h3>
              <button
                onClick={() => setMostraGuidaIos(false)}
                className="text-[#162D4A]/60 hover:text-[#162D4A] text-lg font-bold px-2"
                aria-label="Chiudi"
              >
                ✕
              </button>
            </div>
            <p className="text-xs text-[#0F172A]/80 mb-4">
              Per avere 6amico a schermo intero come una vera applicazione sul tuo iPhone:
            </p>
            <ol className="text-xs space-y-2.5 text-[#0F172A] mb-5">
              <li className="flex items-start gap-2">
                <span className="bg-[#162D4A] text-white rounded-full w-5 h-5 flex items-center justify-center shrink-0 font-bold text-[10px]">1</span>
                <span>Tocca l'icona <strong>Condividi</strong> in basso al centro in Safari (il quadrato con la freccia in su).</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="bg-[#162D4A] text-white rounded-full w-5 h-5 flex items-center justify-center shrink-0 font-bold text-[10px]">2</span>
                <span>Scorri il menù e tocca <strong>"Aggiungi alla schermata Home"</strong>.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="bg-[#162D4A] text-white rounded-full w-5 h-5 flex items-center justify-center shrink-0 font-bold text-[10px]">3</span>
                <span>Conferma con <strong>"Aggiungi"</strong> in alto a destra.</span>
              </li>
            </ol>
            <button
              onClick={() => setMostraGuidaIos(false)}
              className="w-full py-2 bg-[#162D4A] hover:bg-[#0F1F33] text-white text-xs font-bold rounded-lg transition-colors"
            >
              Ho capito
            </button>
          </div>
        </div>
      )}
    </>
  );
}
